module.exports = __webpack_public_path__ + "site_static/img/b2.f92b3e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/b2.png
// module id = lxTt
// module chunks = 0